import {PlusOutlined as AntdPlusOutlined} from '@ant-design/icons';

export default function PlusOutlined(props) {
  return <AntdPlusOutlined {...props} />;
}
